import styled from '@emotion/styled';

export const InputContainer = styled.div`
	width: auto;
	position: relative;

	> input {
		padding-right: 4rem;

		body[dir='rtl'] & {
			padding-right: var(--inputPadding);
			padding-left: 4rem;
		}
	}
`;

export const IconContainer = styled.div`
	position: absolute;
	display: flex;
	align-items: center;
	top: 1.4rem;
	right: 1.5rem;
	color: var(--content-3);

	body[dir='rtl'] & {
		right: unset;
		left: 1.5rem;
	}
`;
